import React from 'react';
import { useNavigate } from 'react-router-dom';

interface CardProps {
  title: string;
  description: string;
  icon: string;
  color: 'indigo' | 'emerald' | 'amber' | 'pink';
  to?: string;
  onClick?: () => void;
}

const Card: React.FC<CardProps> = ({
  title,
  description,
  icon,
  color,
  to,
  onClick,
}) => {
  const navigate = useNavigate();

  const colorClasses = {
    indigo: 'bg-indigo-100 dark:bg-indigo-900/30 border-indigo-300 dark:border-indigo-600 hover:border-indigo-500 dark:hover:border-indigo-400',
    emerald: 'bg-emerald-100 dark:bg-emerald-900/30 border-emerald-300 dark:border-emerald-600 hover:border-emerald-500 dark:hover:border-emerald-400',
    amber: 'bg-amber-100 dark:bg-amber-900/30 border-amber-300 dark:border-amber-600 hover:border-amber-500 dark:hover:border-amber-400',
    pink: 'bg-pink-100 dark:bg-pink-900/30 border-pink-300 dark:border-pink-600 hover:border-pink-500 dark:hover:border-pink-400',
  };

  const iconBgClasses = {
    indigo: 'bg-indigo-500',
    emerald: 'bg-emerald-500',
    amber: 'bg-amber-500',
    pink: 'bg-pink-500',
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
    } else if (to) {
      navigate(to);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`
        w-full p-6 rounded-3xl border-4 transition-all duration-300
        hover:scale-105 hover:shadow-xl active:scale-95
        ${colorClasses[color]}
        text-left
      `}
    >
      <div className={`w-16 h-16 ${iconBgClasses[color]} rounded-2xl flex items-center justify-center mb-4`}>
        <span className="text-3xl">{icon}</span>
      </div>
      <h3 className="text-2xl font-bold text-gray-800 dark:text-white mb-2">{title}</h3>
      <p className="text-gray-600 dark:text-gray-300">{description}</p>
    </button>
  );
};

export default Card;
